import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Logo from './images/logo-full.png';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import eventIMG from './images/event-img.png';
import Carousel from 'react-bootstrap/Carousel';
import Arko from './images/arko.png';
import facebooklogo from './images/facebook.png';
import youtubelogo from './images/youtube.png';
import instagramlogo from './images/instagram.png';
import mediaImg1 from './images/media1.jpg';
import mediaImg2 from './images/media2.jpg';
import mediaImg3 from './images/media3.jpg';
import Card from "react-bootstrap/Card";
import Stack from "react-bootstrap/Stack";
import singerpic from './images/singer1.jpg';
import Isaan from './images/Ishaan.png';
import Kutal from './images/kutal.png';
import EPR from './images/EPR-Iyar.png';
import pogo from './images/POGO-logo.jpg';
import ohcalcutta from './images/oh-calcutta-logo.jpg';


function App() {

  const reviews = [
    { _id: 1, text: "abc" },
    { _id: 2, text: "def" },
    { _id: 3, text: "ghi" },
    { _id: 4, text: "jkl" },
    { _id: 5, text: "mno" },
    { _id: 6, text: "pqr" },
    { _id: 7, text: "stu" },
    { _id: 8, text: "vwx" },
    { _id: 9, text: "yza" }
  ];

  return (

    <div>

    <div className="bannerTop">
        <div className='overlay absolute'></div>
        <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="#home">
          <img src={Logo} className='logoSize'/>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className='navBG rounded-full py-3 px-3'>
          <Nav className="me-auto flex justify-between w-full">
            <Nav.Link href="#home" className='text-white font-med'>Home</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>About Us</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Artist</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Influencers</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Media Engagement</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Brand Promotion</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Events</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Booking</Nav.Link>
            <Nav.Link href="#link" className='text-white font-med'>Contact  Us</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    <div className='bannerTXT relative'>
      <Container>
        <h1 className='text-white uppercase'>Biggest<br/> Event 2025</h1>
        <p className='text-white font-lg fontPop pt-1 w-full md:w-2/4'>
        More than a talent management company; we are a community of dream weavers and strategists dedicated to nurturing talent and amplifying their reach.
        </p>
        <button className='rounded-full py-3 px-16 mt-2 text-white fontPop'>
          PURCHASE TICKET
        </button>
      </Container>
    </div>
   </div>
   <section>
      <Container className='py-20'>
          <Row>
              <Col xs={12} lg={6}>
                <img src={eventIMG} className='whoweR'/>
              </Col>
              <Col xs={12} lg={6} className='whoweRTXT'>
                <h2>Who We Are?</h2>
                <p className='text-white fontPop pt-12 leading-relaxed text-justify'>
                CeleBeeTree.com is more than a talent management company; we are a
                community of dream weavers and strategists dedicated to nurturing talent and
                amplifying their reach. Inspired by the industriousness of bees and the growth
                of trees, our name symbolizes collaboration, hard work, and a strong
                foundation for success. We work with artists, influencers, and brands,
                building synergies that lead to impactfull results and memorable campaigns.
                </p>
              </Col>
          </Row>
      </Container>
   </section> 
   <section>
    <Container className='py-20'>
      <Row className='whoweRTXT'>
        <h2 className='text-center'>What We Do?</h2>
      </Row>
      <Row className='service pb-20'>
        <Col xs={12} lg={3} className='pt-12'>
          <div className='p-3 serviceicon'>
          <div className='iconRound primaryGradient rounded-full text-center flex justify-center items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>
          </div>
          <h3 className='text-white pt-6 fontPop'>Artist <br/> Booking</h3>
          <p className='text-white pt-6 fontPop'>
          From musical sensations to emerging stars, we connect world-class artists with events, shows, and collaborations that resonate.
          </p>
          </div>
        </Col>
        <Col xs={12} lg={3} className='pt-12'>
          <div className='p-3 serviceicon'>
          <div className='iconRound primaryGradient rounded-full text-center flex justify-center items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>
          </div>
          <h3 className='text-white pt-6 fontPop'>Influencer <br/> Management</h3>
          <p className='text-white pt-6 fontPop'>
          We empower influencers to grow their personal brands while helping businesses leverage the power of social media to reach target audiences.
          </p>
          </div>
        </Col>
        <Col xs={12} lg={3} className='pt-12'>
          <div className='p-3 serviceicon'>
          <div className='iconRound primaryGradient rounded-full text-center flex justify-center items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>
          </div>
          <h3 className='text-white pt-6 fontPop'>Media <br/> Engagement</h3>
          <p className='text-white pt-6 fontPop'>
            Our strategic media outreach ensures your story reaches the right platforms, enhancing visibility and reputation.
          </p>
          </div>
        </Col>
        <Col xs={12} lg={3} className='pt-12'>
          <div className='p-3 serviceicon'>
          <div className='iconRound primaryGradient rounded-full text-center flex justify-center items-center'>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
            </svg>
          </div>
          <h3 className='text-white pt-6 fontPop'>Brand <br/> Promotion</h3>
          <p className='text-white pt-6 fontPop'>
          By blending creativity with analytics, we design campaigns that connect brands with their audience, driving engagement and results.
          </p>
          </div>
        </Col>
       
        
      </Row>
    </Container>
   </section>
   <section className='colorSection'>
    <div className='colorOverlay'></div>
    <Container className='relative py-10 md:py-20'>
      <Row>
        <h2 className='ColorBGHead text-center text-white'>Artist Booking</h2>
        <p className='text-white text-center py-4 px-20'>
        Make your event unforgettable with CeleBeeTree’s artist and celebrity booking services. Whether it’s a corporate event, wedding, concert, or brand launch, we connect you with renowned celebrities, musicians, and entertainers to elevate the experience. From initial coordination to seamless execution, our team ensures hassle-free bookings tailored to your needs. Let CeleBeeTree bring star power to your special occasion!
        </p>
      </Row>
      <Row className='pt-20'>
        <Col xc={12} md={3} className='flex justify-center flex-col items-center'>
            <div className='imgCarousel'>
              <Carousel>
                <Carousel.Item interval={2000}>
                  <img src={Isaan}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Isaan}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Isaan}/>
                </Carousel.Item>
              </Carousel>
            </div>
            <p className='text-white pt-10'>Ishan</p>
            <p>Singer</p>
        </Col>
        <Col xc={12} md={3} className='flex justify-center flex-col items-center'>
            <div className='imgCarousel'>
              <Carousel>
                <Carousel.Item interval={2000}>
                  <img src={Arko}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Arko}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Arko}/>
                </Carousel.Item>
              </Carousel>
            </div>
            <p className='text-white pt-10'>Arkodeep</p>
            <p>Singer</p>
        </Col>
        <Col xc={12} md={3} className='flex justify-center flex-col items-center'>
            <div className='imgCarousel'>
              <Carousel>
                <Carousel.Item interval={2000}>
                  <img src={Kutal}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Kutal}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={Kutal}/>
                </Carousel.Item>
              </Carousel>
            </div>
            <p className='text-white pt-10'>Kutal</p>
            <p>Music Director, Musician & Singer</p>
        </Col>
        <Col xc={12} md={3} className='flex justify-center flex-col items-center'>
            <div className='imgCarousel'>
              <Carousel>
                <Carousel.Item interval={2000}>
                  <img src={EPR}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={EPR}/>
                </Carousel.Item>
                <Carousel.Item interval={2000}>
                  <img src={EPR}/>
                </Carousel.Item>
              </Carousel>
            </div>
            <p className='text-white pt-10'>EPR Iyer</p>
            <p>Rapper & Singer</p>
        </Col>
      </Row>
    </Container>
   </section>
   <section>
      <Container className='py-20'>
        <Row className='py-20'>
          <Col xs={12} md={8}>
            <div className='whoweRTXT'>
              <h2>Influencer Engagement <br/>& Marketing with <br/> CeleBeeTree</h2>
              <p className='text-white pr-0 pt-10 md:pr-20 text-justify'>
                 Boost your product, brand, or event with CeleBeeTree’s influencer marketing services. We connect you with top-tier influencers across niches to create impactful campaigns that resonate with your target audience. From promoting products to driving event awareness, our team crafts authentic and engaging content strategies for maximum reach and results. Let CeleBeeTree help your brand shine through influencer power!
              </p>
            </div>
          </Col>
          <Col xs={12} md={4} className='px-5'>
              <div className='rounded bg-white p-4'>
                  <div><img src={Arko} className='w-full'/></div>
                  <div className='flex justify-between items-center'>
                    <div className='singerTXT'>
                        <p className='singerName'>Arkodeep</p>
                        <p className='m-0'>Folk SInger</p>
                    </div>
                    <div className='socialMediaBG flex'>
                      <div className='mx-1 relative'>
                        <div className='smNumber bg-black text-white text-sm flex items-center justify-center'>12</div>
                        <img src={facebooklogo} />
                      </div>
                      <div className='mx-1 relative'>
                        <div className='smNumber bg-black text-white text-sm flex items-center justify-center'>12</div>
                        <img src={youtubelogo}/>
                      </div>
                      <div className='mx-1 relative'>
                        <div className='smNumber bg-black text-white text-sm flex items-center justify-center'>12</div>
                        <img src={instagramlogo}/>
                      </div>
                    </div>
                  </div>
              </div>
          </Col>
        </Row>
      </Container>
   </section>
   <section className='bannerMedia'>
   <div className='bannerOverlay'></div>
   <Container className='pb-28 relative'>
    <Row>
      <Col>
        <div className='whoweRTXT  py-16'>
            <h2 className='text-center pb-10'>Media Engagement</h2>
        </div>
      </Col>
    </Row>
    <Row>
      <Col md={4} xs={12} className='py-20 mediaEgnmntTXT'>
        <ul>
          <li className='text-white py-2'>Join 85+ Media Network </li>
          <li className='text-white py-2'>Engage your Band on Print or Digital Media</li>
          <li className='text-white py-2'> Grow your business 30X faster</li>
          <li className='text-white py-2'>Create your brand identity. </li>
          <li className='text-white py-2'>Build Reputation</li>
        </ul>
      </Col>
      <Col md={8} xs={12}>
        <Row>
          <Col>
            <div><img src={mediaImg1}/></div>
          </Col>
          <Col>
            <div><img src={mediaImg2}/></div>
          </Col>
          <Col>
            <div><img src={mediaImg3}/></div>
          </Col>
        </Row>
      </Col>
    </Row>
    </Container>
   </section>
   <section className='clientBG flex'>
    <div className='clientTxt'>Clinets</div>
    <div className='clientCarousel'>
    <Carousel>
          {reviews.map((review, index) => (
            <Carousel.Item>
              <Stack
                direction="horizontal"
                className="w-full align-items-center"
                gap={4}
              >
                <Card className='clientsBox'>
                  <img src={pogo} className='w-full'/>
                </Card>
                <Card className='clientsBox'>
                <img src={ohcalcutta} className='w-full'/>
                </Card>               
              </Stack>
            </Carousel.Item>
          ))}
        </Carousel>
    </div>
   </section>
   <section className='gradientBG'>
   <Container className='py-20'>
    <Row>
      <Col xs={12}>
        <div className='whoweRTXT'>
            <h2 className='text-center'>Brand Promotion</h2>
        </div>
      </Col>
    </Row>
    <Row>
      <Col sm={6} xs={12}>
        <div className='promotionTXT my-20'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
          </svg>
          <h3 className='mt-2 text-white'>Celebrity & Influencer-Centric Services</h3>
          <ul>
            <li className='text-white py-2'>Promote Your Brand by Celebrity</li>
            <li className='text-white py-2'>Promote Your Brand by Influencers</li>
            <li className='text-white py-2'>Engage Brand Ambassadors</li>
            <li className='text-white py-2'>Celebrity Event Appearances</li>
          </ul>
        </div>
      </Col>
      <Col sm={6} xs={12}>
        <div className='promotionTXT my-20'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
          </svg>
          <h3 className='mt-2 text-white'>Celebrity & Influencer-Centric Services</h3>
          <ul>
            <li className='text-white py-2'>Promote Your Brand by Celebrity</li>
            <li className='text-white py-2'>Promote Your Brand by Influencers</li>
            <li className='text-white py-2'>Engage Brand Ambassadors</li>
            <li className='text-white py-2'>Celebrity Event Appearances</li>
          </ul>
        </div>
      </Col>
    </Row>
    <Row>
      <Col sm={6} xs={12}>
        <div className='promotionTXT my-20'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
          </svg>
          <h3 className='mt-2 text-white'>Celebrity & Influencer-Centric Services</h3>
          <ul>
            <li className='text-white py-2'>Promote Your Brand by Celebrity</li>
            <li className='text-white py-2'>Promote Your Brand by Influencers</li>
            <li className='text-white py-2'>Engage Brand Ambassadors</li>
            <li className='text-white py-2'>Celebrity Event Appearances</li>
          </ul>
        </div>
      </Col>
      <Col sm={6} xs={12}>
        <div className='promotionTXT my-20'>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="#fff">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
          </svg>
          <h3 className='mt-2 text-white'>Celebrity & Influencer-Centric Services</h3>
          <ul>
            <li className='text-white py-2'>Promote Your Brand by Celebrity</li>
            <li className='text-white py-2'>Promote Your Brand by Influencers</li>
            <li className='text-white py-2'>Engage Brand Ambassadors</li>
            <li className='text-white py-2'>Celebrity Event Appearances</li>
          </ul>
        </div>
      </Col>
    </Row>
      
   </Container>
   </section>
   <section>
      <Container className='py-20'>
        <Row className='pt-12'>
          <Col xs={12} sm={4}>
            <h2 className='text-white text-2xl'>
              Event Booking & Upcoming 
              Events with CeleBeeTree
            </h2>
          </Col>
          <Col sm={1}></Col>
          <Col xs={12} sm={7}>
            <p className='text-white text-sm'>
               At CeleBeeTree, we specialize in curating and managing extraordinary events that leave lasting impressions. Whether it’s live concerts, influencer meet-and-greets, product launches, or corporate events, we connect you with the best artists
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
          <div className="container-fluid">
        <Carousel style={{ height: 500 }}>
          {reviews.map((review, index) => (
            <Carousel.Item style={{ height: 500 }}>
              <Stack
                direction="horizontal"
                className="h-100 justify-content-center align-items-center"
                gap={4}
              >
                <Card style={{ width: "24%" }}>
                  <img src={singerpic} className='w-full'/>
                </Card>

                <Card style={{ width: "24%" }}>
                <img src={singerpic} className='w-full'/>
                </Card>

                <Card style={{ width: "24%" }}>
                <img src={singerpic} className='w-full'/>
                </Card>

                <Card style={{ width: "24%" }}>
                <img src={singerpic} className='w-full'/>
                </Card>
              </Stack>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
          </Col>
        </Row>
      </Container>
   </section>
   <section className='mapBox'>
    <div className='mapLocation'>
          
    </div>
    <div className='enqueryForm'>

    </div>
   </section>
   <footer>
    <section className='bg-black w-full'>
       <Container>
        <Row>
            <Col sm={5} xs={12} className='footerAbout text-white p-10 pr-20'>
                <img src={Logo} className='footerLogo'/>
                <h2 className='uppercase pt-10'>About Us</h2>
                <p className='pb-10'>
                Follow us for more info.
                </p>
            </Col>
            <Col sm={4} xs={12} className='bg-white'>
              <div className='p-4 addressFooter w-full'>
                  <h2 className='uppercase text-center pb-8'>Get in Touch</h2> 
                  <p>Rooted in Creativity...</p>
                  <p>Mumbai | Kolkata | Bengaluru | Delhi | Siliguri</p>
                  <p>Phone: +91-8013523283 / 8967935862</p>
                  <p>Email: events@celebeetree.com</p>
              </div>
            </Col>
        </Row>  
    </Container>
    </section>
   <section className='bg-white p-2'>
    <Container>
      <Row>
        <Col><p className='belowFooter'>from the house of ZuriMorse India</p></Col>
      </Row>
    </Container>
   </section>
   </footer>
  </div>

  );
}

export default App;